var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 15,
    viewBox: "0 0 102 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.707 8.20711C102.098 7.81658 102.098 7.18342 101.707 6.79289L95.3431 0.428932C94.9526 0.0384078 94.3195 0.0384078 93.9289 0.428932C93.5384 0.819457 93.5384 1.45262 93.9289 1.84315L99.5858 7.5L93.9289 13.1569C93.5384 13.5474 93.5384 14.1805 93.9289 14.5711C94.3195 14.9616 94.9526 14.9616 95.3431 14.5711L101.707 8.20711ZM0 8.5H101V6.5H0V8.5Z",
    fill: "#54D4BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/Arrow 4.4be55c7392ffb7367f69cd93f64f77d2.svg";
export { ForwardRef as ReactComponent };